import { Tooltip } from "react-tooltip";

interface ProgressBarProps {
	id: number | undefined;
	started?: number;
	completed?: number;
	assigned: number;
	completedLabel?: string;
	showStartedOnly?: boolean;
	barColor?: string;
}

export default function ProgressBar(props: ProgressBarProps) {
	const fillPercentage =
		(((props.showStartedOnly ? props.started : props.completed) ?? 0) / props.assigned) * 100;
	const fillPercentageString = fillPercentage.toString();

	const startedContent =
		`<span class="text-zinc-300"><b>Started: </b></span>` + props.started + " students";
	const completedContent =
		`<span class="text-green-600"><b>${props.completedLabel}: </b></span>` +
		props.completed +
		" students";

	const tooltipContent = props.showStartedOnly
		? startedContent
		: startedContent + "</br>" + completedContent;

	return (
		<>
			<div
				data-tooltip-id={`progress-${props.id}`}
				data-tooltip-html={tooltipContent}
				className="w-full inline-flex bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 progress-container">
				<div
					className={`${props.barColor ?? "bg-green-600"} h-2.5 rounded-full progress-bar`}
					style={{ width: `${fillPercentageString}%` }}></div>
			</div>
			<Tooltip className="z-10" id={`progress-${props.id}`}></Tooltip>
		</>
	);
}
